// extracted by mini-css-extract-plugin
export default {"link":"HighestRanked_link__YcoXp","headline":"HighestRanked_headline__sKIMo","grid":"HighestRanked_grid__WAnb3"};